import styled from "styled-components";

export const CustomButtonContainer = styled.button`
  background-color: transparent;
  border: 1px solid #269bd5;
  font-size: 13px;
  font-weight: 400;
  background-color: #269bd5;
  color: white;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  min-width: 64px;
  padding: 4px 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #0582c0;
    color: #fff;
    border: 1px solid #269bd5;
  }
  &:disabled {
    background-color: #c2c2c2;
    cursor: no-drop;
    border: 1px solid #c2c2c2;
  }
`;
